import PropTypes from 'prop-types';

export default function Column({ children, className, desktopOnly = false }) {
    return (
        <div
            className={`${
                desktopOnly ? 'esc-ii-hidden lg:esc-ii-flex' : 'esc-ii-flex'
            } esc-ii-flex-col${
                className ? ' ' + className : ''
            }`}
        >
            {children}
        </div>
    );
}

Column.propTypes = {
    className: PropTypes.string,
};
